import DateFnsUtils from '@date-io/date-fns'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import FormControl from '@material-ui/core/FormControl'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import Select from '@material-ui/core/Select'
import Snackbar from '@material-ui/core/Snackbar'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import Alert from '@material-ui/lab/Alert'
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import { makeStyles } from '@material-ui/styles'
import addDays from 'date-fns/addDays'
import isValid from 'date-fns/isValid'
import { ptBR } from 'date-fns/locale'
import React, { useState } from 'react'
import { TbCalendarEvent, TbSearch } from 'react-icons/tb'

import { sendDependentes } from '../../services/agendamento'
import { checkCPF } from '../../services/auth'
import theme from '../../services/theme-service'
import { cpfMask, removeCpfMask } from '../../utils/cpfFormat'
import getCookie from '../../utils/getCookies'
const listaParentesco = [
  { id: 0, option: 'Filho(a)' },
  { id: 1, option: 'Irmão(ã)' },
  { id: 2, option: 'Pai/Mãe' },
  { id: 3, option: 'Avô/Avó' },
  { id: 4, option: 'Cônjugue' },
  { id: 5, option: 'Neto(a)' },
  { id: 6, option: 'Sogro(a)' },
  { id: 7, option: 'Outros' },
]

interface RegisterDependentFormProps {
  onCancel: () => void
  onSuccess?: () => void
}

const useStyles = makeStyles((theme: any) => ({
  container: {
    width: '100%',
    maxWidth: 536,
    padding: '24px',
    border: '1px solid #DAE1EF',
    borderRadius: 4,
    backgroundColor: '#fff',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      border: 'none',
      borderRadius: 0,
      maxWidth: '100%',
    },
  },
  header: {
    marginBottom: 24,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 16,
    },
  },
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 600,
    color: '#111827',
    marginBottom: 8,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(14),
    color: '#6B7280',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(13),
    },
  },
  formControl: {
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
  colorInputText: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#D1D5DB',
      },
      '&:hover fieldset': {
        borderColor: theme.palette.primary.main,
      },
    },
    '& .MuiOutlinedInput-input': {
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(14),
        padding: '14px',
      },
    },
  },
  menuItem: {
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 0',
  },
  adornedEnd: {
    paddingRight: 8,
  },
  root: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-input': {
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(14),
        padding: '14px',
      },
    },
    '& .MuiInputLabel-root': {
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },
  },
  actions: {
    display: 'flex',
    gap: 12,
    justifyContent: 'flex-end',
    marginTop: 24,
    [theme.breakpoints.down('sm')]: {
      marginTop: 16,
      gap: 8,
      flexDirection: 'column-reverse',
      '& button': {
        width: '100%',
      },
    },
  },
  cancelButton: {
    textTransform: 'none',
    border: ' 1px solid #D1D5DB',
    borderRadius: 4,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    padding: '10px 20px',
    color: '#374151',
    '&:hover': {
      backgroundColor: '#F3F4F6',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '12px 16px',
      fontSize: theme.typography.pxToRem(14),
    },
  },
  submitButton: {
    textTransform: 'none',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 500,
    padding: '10px 20px',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '12px 16px',
      fontSize: theme.typography.pxToRem(14),
    },
  },
  snackbar: {
    zIndex: 9999,
  },
  gridContainer: {
    width: '100%',
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      '& .MuiGrid-item': {
        paddingTop: '8px',
        paddingBottom: '8px',
      },
    },
  },
  inputLabel: {
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  outlinedInput: {
    width: '100%',
    '& .MuiOutlinedInput-input': {
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(14),
        padding: '14px',
      },
    },
  },
  cpfLabel: {
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  dependentLabelAsterisk: {
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(12),
    },
    '@media (max-width: 320px)': {
      fontSize: theme.typography.pxToRem(11),
      whiteSpace: 'normal',
      lineHeight: 1.2,
    },
  },
  inputDependent: {
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(12),
      paddingRight: 0,
      paddingLeft: 0,
    },
  },
  deficiencyLabelAsterisk: {
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(12),
    },
  },
  searchIconButton: {
    padding: 0,
  },
}))

export default function RegisterDependentForm({
  onCancel,
  onSuccess,
}: RegisterDependentFormProps): JSX.Element {
  const classes = useStyles()

  // Estados do formulário
  const [cpfDependente, setCpfDependente] = useState<string>('')
  const [nomeDependente, setNomeDependente] = useState<string>('')
  const [birthDateDependente, setBirthDateDependente] = useState<Date | null>(
    new Date(),
  )
  const [emailDependente, setEmailDependente] = useState<string>('')
  const [parentesco, setParentesco] = useState<string>('')
  const [isDeficiente, setIsDeficiente] = useState<boolean | null>(null)

  // Estados de validação e controle
  const [loading, setLoading] = useState<boolean>(false)
  const [errorCpfDependente, setErrorCpfDependente] = useState<string>('')
  const [errorNameDependente, setErrorNameDependente] = useState<string>('')
  const [isSave, setIsSave] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>('')
  const [showErrorSnackbar, setShowErrorSnackbar] = useState<boolean>(false)
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState<boolean>(false)
  const token: string | null = getCookie('gov_access_token_sso')
  const matchesMobile = useMediaQuery('(max-width: 660px)')

  const handleCheckCPF = async () => {
    const cpf = removeCpfMask(cpfDependente)
    if (cpf.length === 11) {
      try {
        setLoading(true)
        const { data } = await checkCPF(removeCpfMask(cpfDependente))

        if (data?.dados_sefaz?.Erro) {
          setErrorCpfDependente(data.dados_sefaz.Erro.Mensagem)
          return
        }

        setNomeDependente(data?.nome || '')
        if (data?.dados_sefaz?.DataNascimento) {
          const birthDate = new Date(data.dados_sefaz.DataNascimento)
          if (isValid(birthDate)) {
            setBirthDateDependente(addDays(birthDate, 1))
          }
        }
      } catch (e) {
        console.error('Erro ao buscar CPF:', e)
        setErrorCpfDependente('Erro ao buscar dados do CPF')
      } finally {
        setLoading(false)
      }
    }
  }

  const SearchButton = () => (
    <IconButton
      onClick={handleCheckCPF}
      disabled={loading}
      className={classes.searchIconButton}
    >
      <TbSearch className={classes.icon} />
    </IconButton>
  )

  const validateForm = (): boolean => {
    let isValid = true
    setIsSave(true)

    if (!cpfDependente || cpfDependente.length < 11) {
      setErrorCpfDependente('CPF inválido')
      isValid = false
    }

    if (!nomeDependente || nomeDependente.trim() === '') {
      setErrorNameDependente('Nome é obrigatório')
      isValid = false
    }

    if (!parentesco) {
      isValid = false
    }

    if (isDeficiente === null) {
      isValid = false
    }

    if (!birthDateDependente) {
      isValid = false
    }

    return isValid
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    if (!validateForm()) {
      return
    }

    try {
      setLoading(true)

      if (!token) {
        setErrorMessage('Token de autenticação não encontrado')
        setShowErrorSnackbar(true)
        return
      }

      if (!birthDateDependente) {
        setErrorMessage('Data de nascimento é obrigatória')
        setShowErrorSnackbar(true)
        return
      }

      if (isDeficiente === null) {
        setErrorMessage('Informe se é portador de deficiência')
        setShowErrorSnackbar(true)
        return
      }

      await sendDependentes(
        token,
        nomeDependente,
        birthDateDependente,
        isDeficiente,
        parentesco,
        removeCpfMask(cpfDependente),
        emailDependente,
      )

      setShowSuccessSnackbar(true)

      setTimeout(() => {
        if (onSuccess) {
          onSuccess()
        }
      }, 1500)
    } catch (error: any) {
      console.error('Erro ao salvar dependente:', error)

      if (error?.response?.data) {
        const errorData = error.response.data

        if (errorData.cpf && Array.isArray(errorData.cpf)) {
          setErrorMessage(errorData.cpf[0])
        } else if (typeof errorData === 'string') {
          setErrorMessage(errorData)
        } else if (errorData.detail) {
          setErrorMessage(errorData.detail)
        } else {
          setErrorMessage('Erro ao cadastrar dependente. Tente novamente.')
        }
      } else {
        setErrorMessage('Erro ao cadastrar dependente. Tente novamente.')
      }

      setShowErrorSnackbar(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography className={classes.title}>Cadastrar Dependente</Typography>
        <Typography className={classes.subtitle}>
          Preencha os dados do dependente para realizar o agendamento
        </Typography>
      </div>

      <form onSubmit={handleSubmit}>
        {loading && (
          <div className={classes.loadingContainer}>
            <CircularProgress color="primary" />
          </div>
        )}

        <Grid container spacing={2} className={classes.gridContainer}>
          {/* CPF */}
          <Grid item xs={12}>
            <FormControl
              required
              variant="outlined"
              fullWidth
              error={!!errorCpfDependente || (isSave && !cpfDependente)}
            >
              <TextField
                id="cpf-dependente"
                type="text"
                label="CPF do dependente"
                required
                variant="outlined"
                onBlur={handleCheckCPF}
                className={classes.colorInputText}
                value={cpfMask(cpfDependente)}
                onChange={(e) => {
                  const newCpf = removeCpfMask(e.target.value)
                  if (newCpf.length <= 11) {
                    // Se o CPF foi alterado, reseta todos os campos dependentes
                    if (newCpf !== cpfDependente) {
                      setNomeDependente('')
                      setBirthDateDependente(new Date())
                      setEmailDependente('')
                      setParentesco('')
                      setIsDeficiente(null)
                    }
                    setCpfDependente(newCpf)
                    setErrorCpfDependente('')
                  }
                }}
                InputProps={{
                  endAdornment: <SearchButton />,
                  style: {
                    color: theme.palette.primary.main,
                  },
                }}
                InputLabelProps={{
                  className: classes.cpfLabel,
                }}
                error={!!errorCpfDependente || (isSave && !cpfDependente)}
                helperText={errorCpfDependente || ''}
                disabled={loading}
              />
            </FormControl>
          </Grid>

          {/* Nome Completo */}
          <Grid item xs={12}>
            <FormControl required variant="outlined" fullWidth>
              <TextField
                id="nome-dependente"
                type="text"
                label="Nome completo do dependente"
                required
                variant="outlined"
                multiline
                value={nomeDependente}
                className={classes.colorInputText}
                onChange={(e) => {
                  setNomeDependente(e.target.value)
                  setErrorNameDependente('')
                }}
                InputProps={{
                  classes: {
                    input: classes.inputDependent,
                  },
                  style: {
                    fontSize: matchesMobile ? 14 : 16,
                  },
                }}
                InputLabelProps={{
                  className: classes.dependentLabelAsterisk,
                }}
                helperText={errorNameDependente || ''}
                error={!!errorNameDependente || (isSave && !nomeDependente)}
                disabled={loading}
              />
            </FormControl>
          </Grid>

          {/* Data de Nascimento */}
          <Grid item xs={12} sm={6}>
            <FormControl
              classes={{ root: classes.root }}
              variant="outlined"
              required
            >
              <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  keyboardIcon={<TbCalendarEvent className={classes.icon} />}
                  InputProps={{
                    className: classes.menuItem,
                    classes: { adornedEnd: classes.adornedEnd },
                  }}
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  maxDate={new Date()}
                  label="Data de nascimento"
                  minDateMessage="A data não pode ser superior ao mês atual"
                  invalidDateMessage="A data informada é inválida"
                  format="dd/MM/yyyy"
                  value={birthDateDependente}
                  InputAdornmentProps={{
                    position: 'end',
                  }}
                  onChange={(date) => {
                    if (date && isValid(date)) {
                      setBirthDateDependente(date)
                    }
                  }}
                  disableToolbar={false}
                  allowKeyboardControl={true}
                  animateYearScrolling={false}
                  disabled={loading}
                />
              </MuiPickersUtilsProvider>
            </FormControl>
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={6}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel
                htmlFor="email-dependente"
                className={classes.inputLabel}
              >
                E-mail do dependente
              </InputLabel>
              <OutlinedInput
                id="email-dependente"
                type="email"
                label="E-mail do dependente"
                className={`${classes.colorInputText} ${classes.outlinedInput}`}
                value={emailDependente}
                onChange={(e) => {
                  setEmailDependente(e.target.value)
                }}
                disabled={loading}
              />
            </FormControl>
          </Grid>

          {/* Parentesco */}
          <Grid item xs={12} sm={6}>
            <FormControl
              classes={{ root: classes.root }}
              variant="outlined"
              required
              className={classes.formControl}
              error={isSave && !parentesco}
            >
              <InputLabel id="parentesco-label">Parentesco</InputLabel>
              <Select
                labelId="parentesco-label"
                id="parentesco-select"
                onChange={(event): void => {
                  setParentesco(event.target.value as string)
                }}
                value={parentesco}
                label="Parentesco"
                classes={{
                  select: classes.menuItem,
                }}
                disabled={loading}
              >
                {listaParentesco.map((unity) => (
                  <MenuItem
                    key={unity.id}
                    className={classes.menuItem}
                    value={unity.option}
                  >
                    {unity.option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Portador de Deficiência */}
          <Grid item xs={12} sm={6}>
            <FormControl
              classes={{ root: classes.root }}
              variant="outlined"
              required
              className={classes.formControl}
              error={isSave && isDeficiente === null}
            >
              <InputLabel
                id="deficiencia-label"
                className={classes.deficiencyLabelAsterisk}
              >
                Portador de deficiência?
              </InputLabel>
              <Select
                labelId="deficiencia-label"
                id="deficiencia-select"
                onChange={(event): void => {
                  setIsDeficiente(
                    (event.target.value as string) === 'Sim' ? true : false,
                  )
                }}
                value={
                  isDeficiente === true
                    ? 'Sim'
                    : isDeficiente === false
                    ? 'Não'
                    : ''
                }
                label="Portador de deficiência?"
                classes={{
                  select: classes.menuItem,
                }}
                disabled={loading}
              >
                <MenuItem className={classes.menuItem} value="Sim">
                  Sim
                </MenuItem>
                <MenuItem className={classes.menuItem} value="Não">
                  Não
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <div className={classes.actions}>
          <Button
            onClick={onCancel}
            className={classes.cancelButton}
            variant="outlined"
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            className={classes.submitButton}
            variant="contained"
            disabled={loading}
          >
            {loading ? 'Salvando...' : 'Cadastrar'}
          </Button>
        </div>
      </form>

      <Snackbar
        open={showErrorSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowErrorSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        className={classes.snackbar}
      >
        <Alert
          onClose={() => setShowErrorSnackbar(false)}
          severity="error"
          elevation={6}
          variant="filled"
        >
          {errorMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={showSuccessSnackbar}
        autoHideDuration={6000}
        onClose={() => setShowSuccessSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        className={classes.snackbar}
      >
        <Alert
          onClose={() => setShowSuccessSnackbar(false)}
          severity="success"
          elevation={6}
          variant="filled"
        >
          Dependente cadastrado com sucesso!
        </Alert>
      </Snackbar>
    </div>
  )
}
